<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">
        View Custom Elements
      </span>
      <a-button
        size="large"
        class="a-header--button slide-down-enter-active"
        type="primary"
      >
        <router-link :to="'/custom-element/add'">
          <a-icon type="plus-square" theme="filled" />
          Add New
        </router-link>
      </a-button>
    </div>
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center pt-35-px">
      <Spinner />
    </div>

    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
            :pagination="pagin"
            :columns="CustomElementListColumn"
            :dataSource="dataTable"
            :tableSize="tableSize"
          >
            <div slot="element_name" slot-scope="{ record }" class="text-truncate d-block">
                {{ record.name }}
            </div>
            <div slot="description" slot-scope="{ record }">
              {{ record.description }}
            </div>
            <div slot="xpath" slot-scope="{ record }">
              {{ record.xpath }}
            </div>
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay" class="operation-menu">
                  <a-menu-item>
                    <div class="full-wh" @click="showDeleteConfirm(record)"><img class="mr-2" src="@assets/icon/delete.svg" /> Delete</div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  // import { NOTIFICATION_TYPES } from '@constants/notifications';
  import { CustomElementListColumn } from '../columnsTable/customElementListColumn';
  import CustomElementService from '../services/customElement.service';

  export default {
    name: 'NotificationList',
    data() {
      var pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        PAGE_OPTIONS,
        // NOTIFICATION_TYPES,
        CustomElementListColumn,
        dataTable: [],
        filterData: [],
        filterParams: {
          search: '',
        },
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0,
        },
        isLoading: true,
        tableSize: {
          height: '',
          width: '',
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      // filter() {
      //   const searchTerm = this.filterParams.search.trim().toLowerCase();
      //   this.filterData = searchTerm ? this.data.filter(item => item.url.url.toLowerCase().includes(searchTerm)) : this.data;
      //   this.pagin = {
      //     current: 1,
      //     pageSize: this.pagin.pageSize,
      //     total: this.filterData.length,
      //   };
      // },
      onDelete(record) {
        CustomElementService.delete(record.id).then(() => {
          this.$showSuccessMessage('Deleted Element');
          this.getList();
        });
      },
      onSearch(event) {
        this.filterParams.search = event.target.value;
        this.filter();
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      async getList() {
        try {
          const responseData = await CustomElementService.getList();
          console.log(responseData)
          this.dataTable = (responseData || []).map((item, index) => ({
            index : index + 1,
            id: item.id,
            name: item.element_name,
            description: item.description,
            xpath: item.xpath
          }));
        } catch (error) {
          this.$showMultiErrorMessage(error.messages || []);
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      showDeleteConfirm(record) {
        this.$confirm({
          title: 'Are you sure to delete this item?',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            this.onDelete(record);
          },
        });
      },
      elSizeChange(size) {
        this.tableSize = size;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .nav-link-detail {
    width: 100%;
    &:hover {
      text-decoration: underline;
    }
  }
  .nav-link-detail {
    display: inline-block;
  }
</style>
